<template>
    <div class="row">
        <div class="col-6">
            <div class="form-group">
                <label for="fecha_sesion">Fecha inicio de la sesión</label>
                <ValidationProvider name="fecha inicio" rules="required" v-slot="{ errors }" id="fecha_sesion" mode="passive">
                    <datetime
                        :min-datetime="fecha(evento.start_event_date)"
                        :max-datetime="fecha(evento.end_event_date)"
                        v-model="sesion.fecha_zulu"
                        :input-class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                        type="datetime"
                        input-id="fecha_zulu"
                        :value-zone="configuracion.TIMEZONE"
                        @close="clearFecha"
                    />
                    <span v-if="errors[0]" id="exampleInputEmail1-error" class="error invalid-feedback" style="display: block">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
        </div>
        <div class="col-6">
            <div class="form-group">
                <label for="end_session_date">Fecha fin de la sesión</label>
                <ValidationProvider name="fecha fin" rules="required" v-slot="{ errors }" id="end_session_date" mode="passive">
                    <datetime :disabled="sesion.fecha_zulu == ''"
                              :min-datetime="evento.calendario ? fechaInicio(sesion.fecha_zulu) : fecha(evento.start_event_date)"
                              :max-datetime="evento.calendario ? fechaFin(sesion.fecha_zulu) : fecha(evento.end_event_date)"
                              v-model="sesion.end_session_date"
                              :input-class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                              type="datetime"
                              input-id="end_session_date"
                              :value-zone="configuracion.TIMEZONE"
                    />
                    <span v-if="errors[0]" class="error invalid-feedback" style="display: block">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
        </div>
        <div class="col-12">
            <div class="form-group">
                <label for="fecha_cierre_venta">Fecha de cierre de venta online</label>
                <datetime
                    v-model="sesion.fecha_cierre_venta"
                    type="datetime"
                    :max-datetime="fecha(evento.end_event_date)"
                    :value-zone="configuracion.TIMEZONE"
                    input-class="form-control"
                    input-id="fecha_cierre_venta"
                />
            </div>
        </div>
        <div class="col-12" v-if="manager.tipo == 1">
            <div class="form-group">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" id="customCheckbox2" v-model="sesion.fecha_provisional"/>
                    <label for="customCheckbox2" class="custom-control-label">Fecha y hora provisional</label>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="form-group">
                <label for="texto">Texto identificativo de la sesión:</label>
                <input type="text" class="form-control" id="texto" placeholder="Texto" v-model="sesion.text"/>
            </div>
        </div>
        <div class="col-12">
            <div class="form-group">
                <label for="texto">Apertura de puertas:</label>
                <input type="text" class="form-control" id="apertura" placeholder="Texto" v-model="sesion.apertura_puertas"/>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        props: ['sesion' , 'evento'],
        data() {
            return {
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            manager() {
                return this.$store.getters.getFooter;
            }
        },
        methods: {
            fecha(date) {
                var dt = new Date(date)
                return dt.toISOString();
            },
            fechaInicio(date) {
                if(date == ''){
                    return this.fecha(this.evento.start_event_date);
                }
                var dt = new Date(date)
                return dt.toISOString();
            },
            fechaFin(date) {
                if(date == ''){
                    return this.fecha(this.evento.end_event_date);
                }
                var dt = new Date(date)
                dt.setHours(23, 59, 59, 999);
                return this.formatDateToISO(dt);
            },
            clearFecha() {
                if(new Date(this.sesion.fecha_zulu) > new Date(this.sesion.end_session_date)){
                    this.sesion.end_session_date = '';
                }
            },
            formatDateToISO(date) {
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const hours = String(date.getHours()).padStart(2, '0') - 2;
                const minutes = String(date.getMinutes()).padStart(2, '0');
                const seconds = String(date.getSeconds()).padStart(2, '0');
                const milliseconds = String(date.getMilliseconds()).padStart(3, '0');

                return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}Z`;
            }
        }
    }
</script>
